import React from 'react';
// react library for routing
import { useLocation, Route, Routes, Navigate } from 'react-router-dom';
// core components
import AdminNavbar from '../components/Navbars/AdminNavbar';
import AdminFooter from '../components/Footers/AdminFooter';
import Sidebar from '../components/Sidebar/Sidebar';

import routes from '../routes';
// import { Store } from '../Store';

// import logotypeGolfamoreBlack from '../assets/img/logo-golfamore-black.png';

function Admin() {
  const [sidenavOpen, setSidenavOpen] = React.useState(true);
  const location = useLocation();

  // const { state, dispatch } = useContext(Store);
  // const { shown } = state.golfamoreInformation;
  // const [show, setShow] = useState(location?.pathname !== '/golfclub-admin/sales');

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const getRoutes = (rts) =>
    rts.map((prop) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === '/golfclub-admin') {
        return <Route path={prop.path} element={prop.component} key={prop.path} exact />;
      }
      return null;
    });

  const getBrandText = () => {
    for (let i = 0; i < routes.length; i++) {
      if (location.pathname.indexOf(routes[i].layout + routes[i].path) !== -1) {
        return routes[i].name;
      }
    }
    return 'Brand';
  };
  // toggles collapse between mini sidenav and normal
  const toggleSidenav = () => {
    if (document.body.classList.contains('g-sidenav-pinned')) {
      document.body.classList.remove('g-sidenav-pinned');
      document.body.classList.add('g-sidenav-hidden');
    } else {
      document.body.classList.add('g-sidenav-pinned');
      document.body.classList.remove('g-sidenav-hidden');
    }
    setSidenavOpen(!sidenavOpen);
  };
  const getNavbarTheme = () =>
    location.pathname.indexOf('admin/alternative-dashboard') === -1 ? 'dark' : 'light';

  // console.log('routes', routes);
  return (
    <>
      {/* {show && (
        <SweetAlerts
          type={null}
          title=""
          // onConfirm={() => dispatch({ type: 'GOLFAMORE_INFORMATION_SHOWN', payload: true })}
          onConfirm={() => setShow(false)}
        >
          <div className="text-center mb-3">
            <img
              src={logotypeGolfamoreBlack}
              alt="logtype"
              className="responsive"
              style={{ width: '250px' }}
            />
          </div>
          <p>{t('default.golfamore-info')}</p>
          <div className="text-center">
            <img src={ghGmCards} alt="cards" style={{ width: '90%' }} />
          </div>
        </SweetAlerts>
      )} */}
      <Sidebar
        routes={routes}
        toggleSidenav={toggleSidenav}
        sidenavOpen={sidenavOpen}
        // logo={{
        //   innerLink: '/',
        //   imgSrc: require('assets/img/brand/argon-react.png').default,
        //   imgAlt: '...'
        // }}
      />
      <div className="main-content">
        <AdminNavbar
          theme={getNavbarTheme()}
          toggleSidenav={toggleSidenav}
          sidenavOpen={sidenavOpen}
          brandText={getBrandText()}
        />
        <Routes>
          {getRoutes(routes)}
          <Route path="*" element={<Navigate to="/golfclub-admin/dashboard" replace />} />
        </Routes>
        <AdminFooter />
      </div>
      {sidenavOpen ? <div className="backdrop d-xl-none" onClick={toggleSidenav} /> : null}
    </>
  );
}

export default Admin;
